//Custom components

import ReviewCard from './ReviewCard';

//Services
import { useApplicationFormContext } from 'features/ApplicationForm/ApplicationFormProvider';
import { formatDate2, formatPhoneNumber } from 'utils';

export default function Review() {
  const { setCurrentStep, data } = useApplicationFormContext();

  const { application, householdIncome, scope } = data;

  const totalIncome = (income: any): number => {
    return (
      Number(income?.wages) +
      Number(income?.otherIncome) +
      Number(income?.pensions)
    );
  };

  return (
    <div className={`space-y-5 px-6 py-4 lg:col-span-9`}>
      <ReviewCard
        title='Application Information'
        handleEdit={() => setCurrentStep(1)}
      >
        <dl>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Name</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.name}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Street Address
            </dt>
            <dd className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2'>
              {application?.streetAddress}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>City</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.city}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              State / Province
            </dt>
            <dd className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2'>
              {application?.state}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Zip / Postal Code
            </dt>
            <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>
              {application?.zipCode}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Home Phone</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {formatPhoneNumber(application?.phone || 'none')}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Date Of Birth</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {formatDate2(application?.dob)}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Neighborhood</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.neighborhood}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Gender</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.gender}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Marital Status
            </dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.maritalStatus}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Disabled</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.disabled}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Is Female Head of Household?
            </dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.femaleHeadOfHousehold}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Do you have $5,000+ in Assets
            </dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.hasAssets}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Received assistance in 3 years
            </dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.receivedAssistance}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Flood Insurance Required & Requested
            </dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.requestedInsurance}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Do children less than 6 years old live/spend substantial time in
              this house?
            </dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.doChildrenLive}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>
              Was the house built before 1978
            </dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.wasBuiltBefore1978}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Race</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {application?.race?.join(', ')}
            </dd>
          </div>
        </dl>
      </ReviewCard>
      {householdIncome?.length > 0 && (
        <ReviewCard
          title='Household Income'
          handleEdit={() => setCurrentStep(2)}
        >
          {householdIncome?.map((income: any) => (
            <div className='bg-white pt-5'>
              <div className='border rounded p-5 bg-white'>
                <h6 className='text-sm normal-case '>
                  {income?.familyMemberName}
                </h6>
                <div className='flex flex-col'>
                  <small className='text-xs text-gray-500 capitalize'>
                    {`Age: ${income.age}`}
                  </small>
                  <small className='text-xs text-gray-500 capitalize'>
                    {`Relation: ${income.relation}`}
                  </small>
                  <small className='text-xs text-gray-500 capitalize'>
                    {`Income: $${totalIncome(income)}`}
                  </small>
                </div>
              </div>
            </div>
          ))}
        </ReviewCard>
      )}
      <ReviewCard title='Scope' handleEdit={() => setCurrentStep(3)}>
        <dl>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Roofing</dt>
            <dd className='mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2'>
              {scope?.roofing ? 'Yes' : 'No' || 'None'}
            </dd>
          </div>

          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Plumbing</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {scope?.plumbing ? 'Yes' : 'No' || 'None'}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Electrical</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {scope?.electrical ? 'Yes' : 'No' || 'None'}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Heat & Air</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {scope?.heatAndAir ? 'Yes' : 'No' || 'None'}
            </dd>
          </div>

          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Structural</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {scope?.structural ? 'Yes' : 'No' || 'None'}
            </dd>
          </div>
          <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
            <dt className='text-sm font-medium text-gray-500'>Painting</dt>
            <dd className='mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2'>
              {scope?.painting ? 'Yes' : 'No' || 'None'}
            </dd>
          </div>
        </dl>
      </ReviewCard>
    </div>
  );
}
